import clsx from 'clsx';
import type { Range } from '@/lib/admin-types';

export type RangePickerProps<T extends string = Range> = {
  value: T;
  onChange: (r: T) => void;
  options?: readonly T[];
};

const DEFAULT_OPTIONS: Range[] = ['7d', '30d', '90d'];

export function RangePicker<T extends string = Range>({
  value,
  onChange,
  options,
}: RangePickerProps<T>) {
  const choices = (options ?? DEFAULT_OPTIONS) as readonly T[];
  return (
    <div className="inline-flex h-8 items-center rounded-lg border border-nova-border bg-nova-muted p-0.5">
      {choices.map((opt) => (
        <button
          key={opt}
          type="button"
          onClick={() => onChange(opt)}
          className={clsx(
            'h-7 rounded-md px-2.5 text-xs font-medium transition-colors',
            value === opt
              ? 'bg-nova-primary text-nova-primary-foreground shadow-sm'
              : 'text-nova-muted-foreground hover:bg-nova-background hover:text-nova-foreground'
          )}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
